var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import Select from 'react-select';
import { Button, Input } from '@project/components/Forms/Fields';
import { VariableBody, VariableSelectContainer, ButtonContainer, VariableContainer, } from './styles';
import InputRenderer from 'components/InputRenderer';
export var VariablePopover = function (_a) {
    var variableTypes = _a.variableTypes, onHide = _a.onHide, onUpdateVariable = _a.onUpdateVariable;
    var _b = useState(''), varName = _b[0], setVarName = _b[1];
    var _c = useState({ value: '', label: '' }), varType = _c[0], setVarType = _c[1];
    var _d = useState({}), varDefaultValue = _d[0], setVarDefaultValue = _d[1];
    return (_jsxs(VariableContainer, { children: [_jsxs(VariableBody, { children: [_jsx(Input, { placeholder: "Name", name: "name", type: "text", value: varName, onChange: function (_a) {
                            var target = _a.target;
                            return setVarName(target.value);
                        } }), _jsx(VariableSelectContainer, { children: _jsx(Select, { onChange: function (value) {
                                setVarType(value);
                                setVarDefaultValue({});
                            }, placeholder: "Type", value: varType, options: variableTypes }) }), _jsx(InputRenderer, { field: {
                            type: varType.value,
                            name: varName,
                        }, sendObject: varDefaultValue, setSendObject: function (val) {
                            var _a;
                            setVarDefaultValue(varType.value === 'timestamp'
                                ? (_a = {}, _a[varName] = val[varName].toISOString(), _a) : val);
                        }, disabled: !varType.value, placeholder: "Default value" })] }), _jsxs(ButtonContainer, { children: [_jsx(Button, __assign({ style: { marginBottom: 0 }, subdued: true, small: true, onClick: onHide }, { children: "Cancel" })), _jsx(Button, __assign({ style: { marginBottom: 0 }, primary: true, small: true, marginLeft: true, disabled: !varName ||
                            !varType.value ||
                            !varDefaultValue ||
                            (varType.value !== 'boolean' && !varDefaultValue[varName]), onClick: function () {
                            return onUpdateVariable(varName, varType.value, varDefaultValue[varName]);
                        } }, { children: "Apply" }))] })] }));
};
export default VariablePopover;
